import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-reporting }}\n{{outlet}}",{ moduleName: "embercom/templates/apps/app/reports/manage.hbs" })